import { render } from "./CreditPage.vue?vue&type=template&id=5818c1f8"
import script from "./CreditPage.vue?vue&type=script&lang=js"
export * from "./CreditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__